import { atom } from "recoil";

export const LoaiDiTichState = atom({
  key: "LoaiDiTichState",
  default: undefined,
});
